import { call, put, takeEvery } from "redux-saga/effects";
import { thoiGianHocLopHCApi } from "../../../api/category/thoiGianHocLopHCApi";
import { IPlanThoiGianHocLopHC } from "../../../model/respone/category/IPlanThoiGianHocLopHC";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eThoiGianHocLopHCActionIds,
  IThoiGianHocLopHCActionTypes,
} from "../../action-types/category/IThoiGianHocLopHCActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.thoiGianHocLopHC;

export function* thoiGianHocLopHCSaga(): any {
  yield takeEvery(eThoiGianHocLopHCActionIds.LOAD_START, loadWorker);
  yield takeEvery(eThoiGianHocLopHCActionIds.SAVE_START, saveWorker);
  yield takeEvery(eThoiGianHocLopHCActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(thoiGianHocLopHCApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IThoiGianHocLopHCActionTypes): any {
  const payload = action.payload as IPlanThoiGianHocLopHC;
  let res: IBaseRespone;
  if (payload.id > 0) {
    res = yield call(thoiGianHocLopHCApi.Update, payload);
  } else {
    res = yield call(thoiGianHocLopHCApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: IThoiGianHocLopHCActionTypes): any {
  const res: IBaseRespone = yield call(
    thoiGianHocLopHCApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
